import React from "react";
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Button as ButtonMU } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import Fab from '@material-ui/core/Fab';
import RadioGroup from '@material-ui/core/RadioGroup';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

// @material-ui/icons
import Refresh from "@material-ui/icons/Refresh";
import Radio from '@material-ui/core/Radio';
import NetworkCheck from "@material-ui/icons/NetworkCheck";
import Dvr from "@material-ui/icons/Dvr";
import PersonAdd from "@material-ui/icons/PersonAdd";
import TransferWithinAStation from "@material-ui/icons/TransferWithinAStation";
import SupervisorAccount from "@material-ui/icons/SupervisorAccount";
import PlaylistAddCheck from "@material-ui/icons/PlaylistAddCheck";
import AddIcon from '@material-ui/icons/Add';




// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import { cardTitle, roseColor } from "assets/jss/material-dashboard-pro-react.jsx";
import JobCardTable from "../../components/JobCardTable";
import Button from "components/CustomButtons/Button.jsx";

import { JOB_STATUSES } from '../../utils/enums'
import { fetchMyWorkspaceRequest } from "../../actions/jobCard";
import { fetchUsersRequest } from "../../actions/users"
import { meterActivationRequest, myWorkspaceReset, assignContractorRequest, managementDecisionRequest, awaitingInspectorRequest, qualityControlRequest, assignTechnicianRequest, assignInspectorCompanyRequest } from "../../actions/myWorkspace";
import JobCardViewComponent from "./jobs/JobCardViewComponent";
import JobCardView from "./jobs/JobCardView";
import { fetchCompaniesRequest } from "../../actions/company";
import { formatStatus } from "../../utils/helpers";



// validation
// add tootTip
class Workspace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keyChange1: '',
      keyChange2: '',
      temperReset: '',
      powerLimit: '',
      preloadedMeterUnitsToken: '',
      inspector: '',
      contractor: '',
      technician: '',
      jobSuccess: null,
      passToContractor: null,
      jobFailedReason: '',
      qualityControlSuccess: null,
      qualityControlFailedReason: '',
      alert: null,
      validationErrors: [],
      validationPromp: null,

      openContractorDialog: false,
      openInspectorDialog: false,
      openMeterTokensDialog: false,
      openManagementDecisionDialog: false,
      openQualityControlDialog: false,
      openFailedExecutionDialog: false,
      openJobViewManagementDecisonDialog: false,
      openJobViewQualityControlDialog: false,
      dialogJobNumber: '',
      dialogOnSubmitFunc: null,
      passToContractor: null,

    };
    this.hideAlert = this.hideAlert.bind(this);
    this.hanleTextChange = this.hanleTextChange.bind(this);
  }
  componentWillMount() {
    this.props.dispatch(fetchMyWorkspaceRequest());
    this.props.dispatch(fetchUsersRequest());
    this.props.dispatch(fetchCompaniesRequest());

  }

  // 1 . when action button is clicked
  onButtonClick(status, jobId, jobNumber) {
    let onSubmitFunc;
    switch (status) {
      case JOB_STATUSES.PENDING_METER_TOKENS:
        onSubmitFunc = this.sumbitResults.bind(this, status, jobId)
        this.setState({ dialogJobNumber: jobNumber, dialogOnSubmitFunc: onSubmitFunc, openMeterTokensDialog: true })
        break;

      case JOB_STATUSES.AWAITING_TECHNICIAN:
        onSubmitFunc = this.sumbitResults.bind(this, status, jobId)
        this.setState({ dialogJobNumber: jobNumber, dialogOnSubmitFunc: onSubmitFunc, openContractorDialog: true })
        break;

      case JOB_STATUSES.AWAITING_MANAGEMENT_DECISION:
        onSubmitFunc = this.sumbitResults.bind(this, status, jobId)
        this.setState({ dialogJobNumber: jobNumber, dialogOnSubmitFunc: onSubmitFunc, openJobViewManagementDecisonDialog: true })
        break;

      case JOB_STATUSES.AWAITING_POST_INSPECTOR:
        onSubmitFunc = this.sumbitResults.bind(this, status, jobId)
        this.setState({ dialogJobNumber: jobNumber, dialogOnSubmitFunc: onSubmitFunc, openInspectorDialog: true })
        break;

      case JOB_STATUSES.AWAITING_QUALITY_CONTROL:
        onSubmitFunc = this.sumbitResults.bind(this, status, jobId)
        this.setState({ dialogJobNumber: jobNumber, dialogOnSubmitFunc: onSubmitFunc, openJobViewQualityControlDialog: true })
        break;

      case JOB_STATUSES.FAILED_EXECUTION:
        onSubmitFunc = this.sumbitResults.bind(this, status, jobId)
        this.setState({ dialogJobNumber: jobNumber, dialogOnSubmitFunc: onSubmitFunc, openFailedExecutionDialog: true })
        break;

      default:
        break;
    }
  }


  //3. when submit button on dialog is clicked
  sumbitResults(status, jobId) {
    switch (status) {
      case JOB_STATUSES.PENDING_METER_TOKENS:
        if (this.validate(JOB_STATUSES.PENDING_METER_TOKENS)) {
          this.setState({
            validationPromp: true
          })
          break;
        }
        const payload = {
          tokens:{
            keyChange1: this.state.keyChange1,
            keyChange2: this.state.keyChange2,
            temperReset: this.state.temperReset,
            powerLimit: this.state.powerLimit,
            preloadedMeterUnitsToken: this.state.preloadedMeterUnitsToken,
          },
          jobReference: jobId
        }
        let successTitle = "Successfully Attached Meter Tokens";
        let successMessage = "Job is now awaiting contractor";
        this.setState({
          successTitle: successTitle, successMessage: successMessage
        })
        this.props.dispatch(meterActivationRequest(payload))
        this.props.dispatch(fetchMyWorkspaceRequest());

        break;

      case JOB_STATUSES.AWAITING_TECHNICIAN:
        if (this.validate(JOB_STATUSES.AWAITING_TECHNICIAN)) {
          this.setState({
            validationPromp: true
          })
          break;
        }
        const constractor_payload = {
          contactor_reference: this.state.contractor._id,
          job_reference: jobId
        }
        const technician_payload = {
          technician_reference: this.state.technician._id,
          job_reference: jobId
        }
        successTitle = (this.state.passToContractor === true) ? "Successfully Assigned Contractor" : "Successfully Assigned Technician";
        successMessage = (this.state.passToContractor === true) ? "Contractor has been notified about the Job Card" : "Technician has been notified about the Job Card";
        this.setState({
          successTitle: successTitle, successMessage: successMessage, contractor: ''
        })

        if(this.state.passToContractor===true){
          this.props.dispatch(assignContractorRequest(constractor_payload))
        }
        if(this.state.passToContractor===false){
          this.props.dispatch(assignTechnicianRequest(technician_payload))
        }
        this.props.dispatch(fetchMyWorkspaceRequest());
        break;


      case JOB_STATUSES.AWAITING_MANAGEMENT_DECISION:
        if (this.validate(JOB_STATUSES.AWAITING_MANAGEMENT_DECISION)) {
          this.setState({
            validationPromp: true
          })
          break;
        }
        let payloadManagementDecision = { jobCardReference: jobId }
        payloadManagementDecision.proceedPostInspection = this.state.jobSuccess
        successTitle = (this.state.jobSuccess == true) ? "Post Inspection" : "Quality Control"
        successMessage = (this.state.jobSuccess == true) ? "Job is now awaiting Inspection" : "Job is now awaiting quality control"
        this.setState({
          successTitle: successTitle, successMessage: successMessage, jobSuccess: null, openJobViewManagementDecisonDialog: false
        })
        this.props.dispatch(managementDecisionRequest(payloadManagementDecision))
        this.props.dispatch(fetchMyWorkspaceRequest());

        break;

      case JOB_STATUSES.AWAITING_POST_INSPECTOR:
        if (this.validate(JOB_STATUSES.AWAITING_POST_INSPECTOR)) {
          this.setState({
            validationPromp: true
          })
          break;
        }

        const constractor_payloads = {
          inspector_company_reference: this.state.contractor._id,
          job_reference: jobId
        }
        let inspectorPayload = { job_reference: jobId }
        inspectorPayload.inspector_reference = this.state.inspector._id

        successTitle = (this.state.passToContractor === true) ? "Successfully Assigned Inspector Company" : "Successfully Assigned Inspector";
        successMessage = (this.state.passToContractor === true) ? "Inspector Company has been notified about the Job Card" : "Inspector has been notified about the Job Card";
        this.setState({
          successTitle: successTitle, successMessage: successMessage, contractor: ''
        })

        if(this.state.passToContractor===true){
          this.props.dispatch(assignInspectorCompanyRequest(constractor_payloads))
          console.log("contactor payload: ", constractor_payloads);
          
        }
        if(this.state.passToContractor===false){
          this.props.dispatch(awaitingInspectorRequest(inspectorPayload))
          console.log("inspector payload: ", inspectorPayload);
          
        }
        this.props.dispatch(fetchMyWorkspaceRequest());
        break;


      case JOB_STATUSES.AWAITING_QUALITY_CONTROL:
        if (this.validate(JOB_STATUSES.AWAITING_QUALITY_CONTROL)) {
          this.setState({
            validationPromp: true
          })
          break;
        }
        let payloadQualityControl = { jobCardRef: jobId }
        payloadQualityControl.isJobSuccess = this.state.qualityControlSuccess
        successTitle = (this.state.qualityControlSuccess == true) ? "Job Quality is Success" : "Quality Failed"
        successMessage = (this.state.qualityControlSuccess == true) ? "Job has been approved complete" : "Job is now awaiting for a new technician"
        this.setState({
          successTitle: successTitle, successMessage: successMessage, qualityControlSuccess: null, openJobViewQualityControlDialog: false })
        this.props.dispatch(qualityControlRequest(payloadQualityControl))
        this.props.dispatch(fetchMyWorkspaceRequest());
        break;

      case JOB_STATUSES.FAILED_EXECUTION:
        if (this.validate(JOB_STATUSES.FAILED_EXECUTION)) {
          this.setState({
            validationPromp: true
          })
          break;
        }
        const awaiting_constractor_payload = {
          contactor_reference: this.state.contractor._id,
          job_reference: jobId
        }
        const awaiting_technician_payload = {
          technician_reference: this.state.technician._id,
          job_reference: jobId
        }
        successTitle = (this.state.passToContractor === true) ? "Successfully Assigned Contractor" : "Successfully Assigned Technician";
        successMessage = (this.state.passToContractor === true) ? "Contractor has been notified about the Job Card" : "Technician has been notified about the Job Card";
        this.setState({
          successTitle: successTitle, successMessage: successMessage, contractor: ''
        })

        if(this.state.passToContractor===true){
          this.props.dispatch(assignContractorRequest(awaiting_constractor_payload))
        }
        if(this.state.passToContractor===false){
          this.props.dispatch(assignContractorRequest(awaiting_technician_payload))
        }
        this.props.dispatch(fetchMyWorkspaceRequest());

        break;

      default:
        break;

    }
  }


  validate(status) {
    let isValid = false;
    let validationErrors = []
    switch (status) {
      case JOB_STATUSES.PENDING_METER_TOKENS:
        if (this.state.preloadedMeterUnitsToken.length < 5) {
          validationErrors.push("Preloaded Meter Units Token should be 20 chars")
          isValid = true
        }
        if (this.state.keyChange1.length < 5) {
          validationErrors.push("Key Change 1 should be 20 chars")
          isValid = true
        }
        if (this.state.keyChange2.length < 5) {
          validationErrors.push("Key Change 2 should be 20 chars")
          isValid = true
        }
        if (this.state.temperReset.length < 5) {
          validationErrors.push("Temper Reset should be 20 chars")
          isValid = true
        }
        if (this.state.powerLimit.length < 5) {
          validationErrors.push("Power Limit should be 20 chars")
          isValid = true
        }
        break;

      case JOB_STATUSES.AWAITING_TECHNICIAN:
          if(this.state.passToContractor === null){
              validationErrors.push("Please select between Assigning Contractor or Assigning Technician")
              isValid = true
          }

        if(this.state.passToContractor === true){
          if (this.state.contractor === "") {
            validationErrors.push("Please select a contractor")
            isValid = true
          }
        }
        
        if(this.state.passToContractor === false){
        if (this.state.technician === "") {
          validationErrors.push("Please select a technician")
          isValid = true
        }
      }

        break;
      case JOB_STATUSES.AWAITING_MANAGEMENT_DECISION:
        if (this.state.jobSuccess === null) {
          validationErrors.push("Please select job status")
          isValid = true
        }
        break;

      case JOB_STATUSES.AWAITING_POST_INSPECTOR:

        if(this.state.passToContractor === null){
            validationErrors.push("Please select between Assigning Contractor or Assigning inspector")
            isValid = true
        }

      if(this.state.passToContractor === true){
        if (this.state.contractor === "") {
          validationErrors.push("Please select a contractor")
          isValid = true
        }
      }
      
      if(this.state.passToContractor === false){
      if (this.state.inspector === "") {
        validationErrors.push("Please select a inspector")
        isValid = true
      }
    }
        break;

      case JOB_STATUSES.AWAITING_QUALITY_CONTROL:
        if (this.state.qualityControlSuccess === null) {
          validationErrors.push("Please select quality status")
          isValid = true
        }
        break;
      case JOB_STATUSES.FAILED_EXECUTION:
        if (this.state.contractor === "") {
          validationErrors.push("Please select a technician")
          isValid = true
        }
        break;
        break;
      default:
        break;
    }
    this.setState({ validationErrors })
    return isValid
  }
  actionButtonsForPendingJobsTab(icon1,viewJobCard) {
    let actionButtons = [<Tooltip title="view job card" placement="top-start">
        <Button onClick={viewJobCard} color="info">
          {icon1}
        </Button>
      </Tooltip>]
      
    
 
    return actionButtons;
  }
  actionButtons(status, icon1, icon2, action, viewJobCard) {
    let actionButtons =[]
    if(viewJobCard){
      actionButtons.push(
        <Tooltip title="view job card" placement="top-start">
        <Button onClick={viewJobCard} color="info">
          {icon1}
        </Button>
      </Tooltip>
      )
    }
    if(action){
      actionButtons.push(
        <Tooltip title={status} placement="top-start">
        <Button onClick={action} color="danger">
          {icon2}
        </Button>
      </Tooltip>
      )
    }
    return actionButtons;
  }
  viewJobCard = jobId => {
    console.log("call view job method");
    
    this.props.history.push(`job/view/${jobId}`)
  };


  displayReason() {
    return <TextField
      margin="dense"
      id="jobFailedReason"
      name="jobFailedReason"
      onChange={this.hanleTextChange}
      label="Reason for Failure"
      type="text"
      fullWidth
    />
  }
  managementDecisionHandler(event) {
    const isSuccess = (event.target.value == 'success') ? true : false
    this.setState({ [event.target.name]: isSuccess });
  }

  handleAssingTechnicianOrPassToContractor(event) {
    const isSuccess = (event.target.value == 'passToContractor') ? true : false
    this.setState({ [event.target.name]: isSuccess });
  }

  hanleTextChange(e) {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  handleTextChange(field, event) {
    this.setState({ [field]: event.target.value });
  }

  hideAlert() {
    this.setState({
      alert: null,
      keyChange1: '',
      keyChange2: '',
      temperReset: '',
      powerLimit: '',
      preloadedMeterUnitsToken: '',
      inspector: '',
      contractor: '',
      jobSuccess: null,
      jobFailedReason: '',
      qualityControlSuccess: null,
      qualityControlFailedReason: '',

      openContractorDialog: false,
      openInspectorDialog: false,
      openMeterTokensDialog: false,
      openManagementDecisionDialog: false,
      openQualityControlDialog: false,
      openFailedExecutionDialog: false,
      dialogJobNumber: '',
      dialogOnSubmitFunc: null,
      passToContractor: null,
    });
    this.reset()
  }

  reset() {
    this.props.dispatch(myWorkspaceReset())
  }

  displayValidationErrors() {
    const errors = this.state.validationErrors
    return <SweetAlert
      danger
      style={{ display: "block", marginTop: "-100px" }}
      title="validation Errors"
      onConfirm={() => this.hideValidationDialog()}
      onCancel={() => this.hideValidationDialog()}
      confirmBtnCssClass={
        this.props.classes.button + " " + this.props.classes.success
      }
    >
      <div>
        {errors.map((item, index) => {

          return <div key={index}> {item}</div>
        })}
      </div>
    </SweetAlert>
  }
  hideValidationDialog() {
    this.setState({ validationPromp: null, validationErrors: [] })
  }

  displayErrorFeedback() {
    const e = this.errorMessage()
    return <SweetAlert
      danger
      style={{ display: "block", marginTop: "-100px" }}
      title="Cancelled"
      onConfirm={() => this.reset()}
      onCancel={() => this.reset()}
      confirmBtnCssClass={
        this.props.classes.button + " " + this.props.classes.success
      }
    >
      <div>
        {e.map((item, index) => {

          return <div key={index}> {item}</div>
        })}
      </div>
    </SweetAlert>
  }

  displaySuccessFeedback() {
    return <SweetAlert
      success
      style={{ display: "block", marginTop: "-100px" }}
      title={this.state.successTitle}
      onConfirm={() => this.hideAlert()}
      onCancel={() => this.hideAlert()}
      confirmBtnCssClass={
        this.props.classes.button + " " + this.props.classes.success
      }
    >
      {this.state.successMessage}
    </SweetAlert>
  }


  displayLoader() {
    return <Dialog
      open={true}
      onClose={this.hideAlert}
      aria-labelledby="form-dialog-title"
    >
      <DialogContent>
        <CircularProgress />
      </DialogContent>
    </Dialog>
  }

  errorMessage() {
    let e = this.props.myWorkspaceData.errors
    if (Array.isArray(e)) {
      let i;
      let el = []
      for (i = 0; i < e.length; i++) {
        let obj = e[i].constraints
        for (var property in obj) {
          el.push(obj[property] + '; ')
        }
      }
      return el

    }
    else if (e.message) {
      return [e.message]
    } else {
      return ["unexpected Error occured"]
    }
  }

  render() {
    const { classes } = this.props;
    const inspectors = this.props.usersData.users ? this.props.usersData.users.filter(x => x.role === 'Inspector') : []
    const contractors = this.props.usersData.users ? this.props.usersData.users.filter(x => x.role === 'Technician' || x.role === 'Contractor') : []
    const companiesList = this.props.companyData.companies || [];


    return (
      <div>

        <div>
          <div style={{ textAlign: "center" }}>
            {this.props.myWorkspaceData.errors ? (this.displayErrorFeedback()) : ('')}
            {this.state.validationPromp ? (this.displayValidationErrors()) : ('')}
            {this.props.myWorkspaceData.success ? (this.displaySuccessFeedback()) : ('')}
            {this.props.myWorkspaceData.loader ? (this.displayLoader()) : ('')}
            {this.props.jobsData.workspaceLoader ? (this.displayLoader()) : ('')}
          </div>
        </div>




        {/* attach tokens dialog */}
        <Dialog
          open={this.state.openMeterTokensDialog}
          onClose={this.hideAlert}
          fullWidth
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title"> Attach meter tokens to this Job Cards</DialogTitle>
          <DialogContent>
            <DialogContentText>Job Card Number: {" " + this.state.dialogJobNumber}</DialogContentText>

            <br />
            <TextField
              autoFocus
              margin="dense"
              id="keyChange1"
              name="keyChange1"
              onChange={this.hanleTextChange}
              label="Key Change 1"
              type="text"
              fullWidth
            />
            <br /><br />
            <TextField
              margin="dense"
              id="keyChange2"
              name="keyChange2"
              onChange={this.hanleTextChange}
              label="Key Change 2"
              type="text"
              fullWidth
            />
             <br /><br />
            <TextField
              autoFocus
              margin="dense"
              id="temperReset"
              name="temperReset"
              onChange={this.hanleTextChange}
              label="Temper Reset"
              type="text"
              fullWidth
            />
            <br /><br />
            <TextField
              margin="dense"
              id="powerLimit"
              name="powerLimit"
              onChange={this.hanleTextChange}
              label="Power Limit"
              type="text"
              fullWidth
            />
             <br /><br />
            <TextField
              autoFocus
              margin="dense"
              id="preloadedMeterUnitsToken"
              name="preloadedMeterUnitsToken"
              onChange={this.hanleTextChange}
              label="Preloaded Meter Units Token"
              type="text"
              fullWidth
            />
            <br />
    
          </DialogContent>
          <DialogActions>
            <Button onClick={this.hideAlert} color="#000">
              Cancel
            </Button>
            <Button onClick={this.state.dialogOnSubmitFunc} color="primary">
              Assign Tokens
            </Button>
          </DialogActions>
        </Dialog>


        {/* Management decision dialog */}
        <Dialog
          open={this.state.openManagementDecisionDialog}
          onClose={this.hideAlert}
          fullWidth
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title"> Management Decision on this Job Card</DialogTitle>
          <DialogContent>
            <DialogContentText>Job Card Number: {" " + this.state.dialogJobNumber}</DialogContentText>

            <GridItem xs={12} sm={12} md={12}>
              <div >
                <br />
                <FormControl component="fieldset" >
                  <RadioGroup
                    aria-label="Job Status"
                    name="jobSuccess"
                    value={this.value}
                    onChange={this.managementDecisionHandler.bind(this)}
                  >
                    <FormControlLabel value={'success'} control={<Radio />} label="Successfully Completed Job" />
                    <FormControlLabel value={'failed'} control={<Radio />} label="Failed To Complete Job" />
                  </RadioGroup>
                </FormControl>
              </div>
              <div >
                {(this.state.jobSuccess === false) ? <TextField
                  margin="dense"
                  id="jobFailedReason"
                  name="jobFailedReason"
                  onChange={this.hanleTextChange}
                  label="Reason for Failure"
                  type="text"
                  fullWidth
                /> : ''}
                <br />
              </div>
            </GridItem>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.hideAlert} color="#000">
              Cancel
            </Button>
            <Button onClick={this.state.dialogOnSubmitFunc} color="primary">
              Submit Decision
            </Button>
          </DialogActions>
        </Dialog>


        {/* quality control dialog */}
        <Dialog
          open={this.state.openQualityControlDialog}
          onClose={this.hideAlert}
          fullWidth
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title"> Quality of this Job Card</DialogTitle>
          <DialogContent>
            <DialogContentText>Job Card Number: {" " + this.state.dialogJobNumber}</DialogContentText>

            <GridItem xs={12} sm={12} md={12}>
              <div >
                <br />
                <FormControl component="fieldset" >
                  <RadioGroup
                    aria-label="Quality Control Status"
                    name="qualityControlSuccess"
                    value={this.value}
                    onChange={this.managementDecisionHandler.bind(this)}
                  >
                    <FormControlLabel value={"success"} control={<Radio />} label="Job Quality has Succeeded" />
                    <FormControlLabel value={"failed"} control={<Radio />} label="Job Quality has failed" />
                  </RadioGroup>
                </FormControl>
              </div>
              <div >
                {(this.state.qualityControlSuccess === false) ? <TextField
                  margin="dense"
                  id="jobFailedReason"
                  name="jobFailedReason"
                  onChange={this.hanleTextChange}
                  label="Reason for Failure"
                  type="text"
                  fullWidth
                /> : ''}
                <br />
              </div>
            </GridItem>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.hideAlert} color="#000">
              Cancel
            </Button>
            <Button onClick={this.state.dialogOnSubmitFunc} color="primary">
              Submit Quality
            </Button>
          </DialogActions>
        </Dialog>


        {/* failed execution dialog */}
        <Dialog
          open={this.state.openFailedExecutionDialog}
          onClose={this.hideAlert}
          fullWidth
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title"> Re-assign a technician to this Job Card</DialogTitle>
          <DialogContent>
            <DialogContentText>Job Card Number: {" " + this.state.dialogJobNumber}</DialogContentText>
            <br />

            <div >
                <br />
                <FormControl component="fieldset" >
                  <RadioGroup
                    aria-label="Job Status"
                    name="passToContractor"
                    value={this.value}
                    onChange={this.handleAssingTechnicianOrPassToContractor.bind(this)}
                    row
                  >
                    <FormControlLabel value={'passToContractor'} control={<Radio />} label="Assign Contractor" />
                    <FormControlLabel value={'assignTechnician'} control={<Radio />} label="Assign Technician" />
                  </RadioGroup>
                </FormControl>
              </div>
              <div >
                {(this.state.passToContractor === false) ? 
                
                
                <GridItem xs={12} sm={12} md={12} justify="center" style={{ margin: "auto" }}>

              <FormControl fullWidth >
                <InputLabel htmlFor="simple-select"> Select Technician *   </InputLabel>
                <Select
                  classes={{
                    select: this.props.classes.select
                  }}
                  value={this.state.contractor}
                  onChange={this.handleTextChange.bind(this, "contractor")}
                  inputProps={{
                    name: "contractor",
                    id: "contractor"
                  }}
                >
                  <MenuItem disabled  >Select Technician</MenuItem>
                  {
                    contractors.map((contractor, index) =>
                      <MenuItem
                        key={index}
                        value={contractor}
                      >
                        {contractor.firstName + " " + contractor.lastName}
                      </MenuItem>
                    )
                  }
                </Select>
              </FormControl>
            </GridItem>

                : ''}
                {(this.state.passToContractor === true) ? 
              <GridItem xs={12} sm={12} md={12}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="simple-select"
                        >
                          Assign Contractor *
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.contractor}
                          onChange={this.handleTextChange.bind(this, "contractor")}
                          inputProps={{
                            name: "contractor",
                            id: "contractor"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Company
                        </MenuItem>
                          {
                            companiesList.map((company, index) =>
                              <MenuItem
                                key={index}
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={company}
                              >
                                {formatStatus(company.comapanyName)}
                              </MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>
                    </GridItem>
                : ''}
                <br />
              </div>
            
            
            </DialogContent>
          <DialogActions>
            <Button onClick={this.hideAlert} color="#000">
              Cancel
            </Button>
            <Button onClick={this.state.dialogOnSubmitFunc} color="primary">
              Re-assign technician
            </Button>
          </DialogActions>
        </Dialog>



        {/* contractor dialog */}
        <Dialog
          open={this.state.openContractorDialog}
          onClose={this.hideAlert}
          fullWidth
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title"> Assign Technician to this Job Card</DialogTitle>
          <DialogContent>
            <DialogContentText>Job Card Number: {" " + this.state.dialogJobNumber}</DialogContentText>
            <br />

            
             <div >
                <br />
                <FormControl component="fieldset" >
                  <RadioGroup
                    aria-label="Job Status"
                    name="passToContractor"
                    value={this.value}
                    onChange={this.handleAssingTechnicianOrPassToContractor.bind(this)}
                    row
                  >
                    <FormControlLabel value={'passToContractor'} control={<Radio />} label="Assign Contractor" />
                    <FormControlLabel value={'assignTechnician'} control={<Radio />} label="Assign Technician" />
                  </RadioGroup>
                </FormControl>
              </div>
              <div >
                {(this.state.passToContractor === false) ? 
                
                
                <GridItem xs={12} sm={12} md={12} justify="center" style={{ margin: "auto" }}>

              <FormControl fullWidth >
                <InputLabel htmlFor="simple-select"> Select Technician *   </InputLabel>
                <Select
                  classes={{
                    select: this.props.classes.select
                  }}
                  value={this.state.technician}
                  onChange={this.handleTextChange.bind(this, "technician")}
                  inputProps={{
                    name: "technician",
                    id: "technician"
                  }}
                >
                  <MenuItem disabled  >Select Technician</MenuItem>
                  {
                    contractors.map((contractor, index) =>
                      <MenuItem
                        key={index}
                        value={contractor}
                      >
                        {contractor.firstName + " " + contractor.lastName}
                      </MenuItem>
                    )
                  }
                </Select>
              </FormControl>
            </GridItem>

                : ''}
                {(this.state.passToContractor === true) ? 
              <GridItem xs={12} sm={12} md={12}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="simple-select"
                        >
                          Assign Contractor *
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.contractor}
                          onChange={this.handleTextChange.bind(this, "contractor")}
                          inputProps={{
                            name: "contractor",
                            id: "contractor"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Company
                        </MenuItem>
                          {
                            companiesList.map((company, index) =>
                              <MenuItem
                                key={index}
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={company}
                              >
                                {formatStatus(company.comapanyName)}
                              </MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>
                    </GridItem>
                : ''}
                <br />
              </div>
            
          </DialogContent>
          <DialogActions>
            <Button onClick={this.hideAlert} color="#000">
              Cancel
            </Button>
            <Button onClick={this.state.dialogOnSubmitFunc} color="primary">
              Assign Technician
            </Button>
          </DialogActions>
        </Dialog>




        {/* inspector dialog */}
        <Dialog
          open={this.state.openInspectorDialog}
          onClose={this.hideAlert}
          fullWidth
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title"> Assign inspector to this Job Card</DialogTitle>
          <DialogContent>
            <DialogContentText>Job Card Number: {" " + this.state.dialogJobNumber}</DialogContentText>
            <br />

            <div >
                <br />
                <FormControl component="fieldset" >
                  <RadioGroup
                    aria-label="Job Status"
                    name="passToContractor"
                    value={this.value}
                    onChange={this.handleAssingTechnicianOrPassToContractor.bind(this)}
                    row
                  >
                    <FormControlLabel value={'passToContractor'} control={<Radio />} label="Pass To Contractor" />
                    <FormControlLabel value={'assignTechnician'} control={<Radio />} label="Assign Inspector" />
                  </RadioGroup>
                </FormControl>
              </div>
              <div >
                {(this.state.passToContractor === false) ? 
                
                
                <GridItem xs={12} sm={12} md={12}>
              <FormControl fullWidth >
                <InputLabel htmlFor="simple-select"> Select Inspector *  </InputLabel>
                <Select
                  value={this.state.inspector}
                  onChange={this.handleTextChange.bind(this, "inspector")}
                  inputProps={{
                    name: "inspector",
                    id: "inspector",
                  }}
                >
                  <MenuItem disabled  >Select Inspector </MenuItem>
                  {
                    inspectors.map((inspector, index) =>

                      <MenuItem
                        key={index}
                        classes={{
                          root: this.props.classes.selectMenuItem,
                          selected: this.props.classes.selectMenuItemSelected
                        }}
                        value={inspector}
                      >
                        {inspector.firstName + " " + inspector.lastName}
                      </MenuItem>
                    )
                  }
                </Select>
              </FormControl>
            </GridItem>

                : ''}
                {(this.state.passToContractor === true) ? 
                  <GridItem xs={12} sm={12} md={12}>
                  <FormControl
                    fullWidth
                  >
                    <InputLabel
                      htmlFor="simple-select"
                    >
                      Assign Contractor *
                  </InputLabel>
                    <Select
                      classes={{
                        select: classes.select
                      }}
                      value={this.state.contractor}
                      onChange={this.handleTextChange.bind(this, "contractor")}
                      inputProps={{
                        name: "contractor",
                        id: "contractor"
                      }}
                    >
                      <MenuItem
                        disabled
                      >
                        Select Company
                    </MenuItem>
                      {
                        companiesList.map((company, index) =>
                          <MenuItem
                            key={index}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected
                            }}
                            value={company}
                          >
                            {formatStatus(company.comapanyName)}
                          </MenuItem>
                        )
                      }
                    </Select>
                  </FormControl>
                </GridItem>
                : ''}
                <br />
              </div>
            
          </DialogContent>
          <DialogActions>
            <Button onClick={this.hideAlert} color="#000">
              Cancel
            </Button>
            <Button onClick={this.state.dialogOnSubmitFunc} color="primary">
              Assign Inspector
            </Button>
          </DialogActions>
        </Dialog>

        {/* full jobview dialog */}
        <Dialog
          open={this.state.openJobViewManagementDecisonDialog}
          onClose={this.hideAlert}
          fullScreen
          aria-labelledby="form-dialog-title"
        >
          <DialogContent>
            <AppBar className={classes.appBar} style={{ position: 'absolute', background: "#00acc1" }}>
              <Toolbar>
                <IconButton edge="start" color="inherit" onClick={() => { this.setState({ openJobViewManagementDecisonDialog: false }) }} aria-label="close">
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title} style={{ marginLeft: "2px", flex: "1", color: "#fff" }}>
                  Management Decision
            </Typography>
                <Button color="primary" onClick={() => { this.setState({ openManagementDecisionDialog: true }) }}>
                  Submit Management Decision
            </Button>
              </Toolbar>
            </AppBar>
            <GridItem xs={12} sm={12} md={12}>
              <br />
              <br />
              <JobCardView jobNumberFromWorkspace={this.state.dialogJobNumber} workspace={true} />
            </GridItem>
          </DialogContent>
        </Dialog>

        <Dialog
          open={this.state.openJobViewQualityControlDialog}
          onClose={this.hideAlert}
          fullScreen
          aria-labelledby="form-dialog-title"
        >
          <DialogContent>
            <AppBar className={classes.appBar} style={{ position: 'absolute', background: "#00acc1" }}>
              <Toolbar>
                <IconButton edge="start" color="inherit" onClick={() => { this.setState({ openJobViewQualityControlDialog: false }) }} aria-label="close">
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title} style={{ marginLeft: "2px", flex: "1", color: "#fff" }}>
                  Quality Control
            </Typography>
                <Button color="danger" onClick={() => { this.setState({ openQualityControlDialog: true }) }}>
                  Submit Quality Evaluation
            </Button>
              </Toolbar>
            </AppBar>
            <GridItem xs={12} sm={12} md={12}>
              <br />
              <br />
              <JobCardView jobNumberFromWorkspace={this.state.dialogJobNumber} workspace={true} />
            </GridItem>
          </DialogContent>
        </Dialog>

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <CustomTabs
              headerColor="info"
              title={
                <ButtonMU style={{ color: 'white' }} onClick={() => this.props.dispatch(fetchMyWorkspaceRequest())}>
                  <Refresh />
                </ButtonMU>
              }
              tabs={[
                {
                  tabName: "Pending Meter Tokens",
                  tabContent: (
                    <JobCardTable
                      jobCards={this.props.jobsData.workspaceJobCards}
                      status={["pending-meter-tokens"]}
                      actionButtons={this.actionButtons.bind(this, "Attach Meter Tokens", <Dvr />, <NetworkCheck />)}
                      viewJobCard={this.viewJobCard}
                      onClickFn2={this.onButtonClick.bind(this, "pending-meter-tokens")}
                    />
                  )
                },
                {
                  tabName: "Awaiting Technician",
                  tabContent: (
                    <JobCardTable
                      jobCards={this.props.jobsData.workspaceJobCards}
                      status={[JOB_STATUSES.AWAITING_TECHNICIAN, JOB_STATUSES.AWAITING_CONTRACTOR_COMPANY]}
                      actionButtons={this.actionButtons.bind(this, "Assign Technician", <Dvr />, <PersonAdd />)}
                      viewJobCard={this.viewJobCard}
                      onClickFn2={this.onButtonClick.bind(this, JOB_STATUSES.AWAITING_TECHNICIAN)}
                    />
                  )
                },
                {
                  tabName: "Management Decision",
                  tabContent: (
                    <JobCardTable
                      jobCards={this.props.jobsData.workspaceJobCards}
                      status={[JOB_STATUSES.AWAITING_MANAGEMENT_DECISION]}
                      actionButtons={this.actionButtons.bind(this, "Management Decision", <Dvr />, <SupervisorAccount />)}
                      viewJobCard={this.viewJobCard}
                      onClickFn2={this.onButtonClick.bind(this, JOB_STATUSES.AWAITING_MANAGEMENT_DECISION)}
                    />
                  )
                },
                {
                  tabName: "Awaiting Inspector",
                  tabContent: (
                    <JobCardTable
                      jobCards={this.props.jobsData.workspaceJobCards}
                      status={[JOB_STATUSES.AWAITING_POST_INSPECTOR, JOB_STATUSES.AWAITING_POST_INSPECTION_COMPANY]}
                      actionButtons={this.actionButtons.bind(this, "Assign Inspector", <Dvr />, <PersonAdd />)}
                      viewJobCard={this.viewJobCard}
                      onClickFn2={this.onButtonClick.bind(this, JOB_STATUSES.AWAITING_POST_INSPECTOR)}
                    />
                  )
                },
                {
                  tabName: "Quality Control",
                  tabContent: (
                    <JobCardTable
                      jobCards={this.props.jobsData.workspaceJobCards}
                      status={[JOB_STATUSES.AWAITING_QUALITY_CONTROL]}
                      actionButtons={this.actionButtons.bind(this, "Control Quality", <Dvr />, <PlaylistAddCheck />)}
                      viewJobCard={this.viewJobCard}
                      onClickFn2={this.onButtonClick.bind(this, JOB_STATUSES.AWAITING_QUALITY_CONTROL)}

                    />
                  )
                },
                {
                  tabName: "Failed Execution",
                  tabContent: (
                    <JobCardTable
                      jobCards={this.props.jobsData.workspaceJobCards}
                      status={[JOB_STATUSES.FAILED_EXECUTION]}
                      actionButtons={this.actionButtons.bind(this, "Re-assign Technician", <Dvr />, <TransferWithinAStation />)}
                      viewJobCard={this.viewJobCard}
                      onClickFn2={this.onButtonClick.bind(this, JOB_STATUSES.FAILED_EXECUTION)}
                    />
                  )
                }
                ,
                {
                  tabName: "Pending Jobs",
                  tabContent: (
                    <JobCardTable
                      jobCards={this.props.jobsData.workspaceJobCards}
                      status = {['pending-meter-request','pending-meter-tokens','assigned-contractor','contractor-in-progress','assigned-post-inspector','post-inspection-in-progress', 'assigned-technician']}
                      actionButtons={this.actionButtonsForPendingJobsTab.bind(this, <Dvr />)}
                      viewJobCard={this.viewJobCard}
                      // onClickFn2 ={()=>{}}
                      showJobAge = {true}
                    />
                  )
                }
              ]}
            />
            <div style={{ textAlign: "center" }}>
              <Fab aria-label="Add"
                style={{
                  backgroundColor: "#26c6da",
                  color: 'white',
                  margin: 0,
                  top: 'auto',
                  right: '30%',
                  bottom: 20,
                  left: 'auto',
                  position: 'fixed',
                }}>
                <AddIcon onClick={() => this.props.history.push("create/jobcard")} />
              </Fab>
            </div>

          </GridItem>

        </GridContainer>
      </div>
    );
  }
}

export default withStyles(sweetAlertStyle)(
  connect(state => ({
    usersData: state.usersState,
    jobsData: state.jobCardState,
    myWorkspaceData: state.myWorkspaceState,
    companyData: state.companyState,
  }))(Workspace)
);
